// @flow
import React from 'react';
import type {
  Node,
} from 'react';

import {
  StyledButton,
} from './styled';

export type ButtonAppearances = 'default' | 'link' | 'primary';

export type ButtonProps = {
  /** The base styling to apply to the button. */
  appearance: ButtonAppearances,
  /** Button's child nodes. */
  children: Node,
  /** Add a classname to the button. */
  className: string,
  /** Set if the button is disabled. */
  isDisabled: boolean,
  /** Change the style to indicate the button is selected. */
  isSelected: boolean,
  /** Handler to be called on click. */
  onClick: { (e: Event): void },
  /** Set the amount of padding in the button. */
  spacing: 'compact' | 'default' | 'none',
  /** Set whether it is a button or a form submission. */
  type: 'button' | 'submit',
};

/**
 * Button
 * @version 1.0.0
 * @author [Ubayd Rahmonzoda](https://github.com/rahmonzoda)
 */
const Button = (
  props: ButtonProps,
): Node => {
  const {
    appearance,
    children,
    className,
    onClick,
    spacing,
    isDisabled,
    isSelected,
    type,
  } = props;
  return (
    <StyledButton
      {...props}
      type={type}
      spacing={spacing}
      className={className}
      appearance={appearance}
      disabled={isDisabled}
      isSelected={isSelected}
      onClick={onClick}
    >
      {children}
    </StyledButton>
  );
};

Button.defaultProps = {
  isDisabled: false,
  isSelected: false,
  children: null,
  className: '',
  type: 'button',
  spacing: 'default',
  appearance: 'default',
  onClick: () => {},
};

export default Button;
